import React from "react";
import { useTheme } from "App/common/ThemeProvider";
import { ImageWithFallback } from "App/common/ImageWithFallback";
import { USER_AVATAR_SIZE } from "App/common/UserAvatar/UserAvatar";
import "App/common/UserAvatar/styles.scss";
import "./styles.scss";

export const Byline = ({
  picture,
  name,
}: {
  picture?: string | null;
  name?: string | null;
}) => {
  const { theme } = useTheme();
  const fallback = name ? name[0].toUpperCase() : "?";

  return (
    <div className="discover-byline">
      <div
        className="highnote-user-avatar"
        data-size={USER_AVATAR_SIZE.MEDIUM}
        data-theme={theme}
      >
        <ImageWithFallback src={picture} fallback={fallback} />
      </div>
      <span className="discover-byline-name">{name}</span>
    </div>
  );
};
